
/**
 * Root saga manages watcher lifecycle
 */
export default function * auth(): Generator {
}
